import styled from "styled-components";

export const StyledInput = styled.input`
  border: 1px solid #a5a5a5;
  display: flex;
  flex: 1;
  height: 50px;
  padding: 2rem;
  font-size: 1.6rem;

  @media (max-width: 1366px) {
    font-size: 1.4rem;
    height: 45px;
  }
`;
